import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalCarritoProductosComponent } from '../componentes/modal-carrito-productos/modal-carrito-productos.component';
import { Globals } from '../globals';
import { Router } from '@angular/router';
import { MdcSnackbar } from '@angular-mdc/web';
import { BuscadorProductosComponent } from '../buscador-productos/buscador-productos.component';
import { BusquedaService } from '../services/BusquedaService';

@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss']
})
export class BottomNavigationComponent {
  constructor(
		public globals: Globals,
		private router: Router,
		public dialog: MatDialog,
		private snackBar: MdcSnackbar,
    private busquedaService: BusquedaService
	) { 
    console.log('cantidad de objetos en el carrito',globals.configuracion.front.cart.productos.length)
  }
  limpiarBusqueda() {
    this.busquedaService.limpiarBusqueda();
  }
  navegarAlInicio() {
    localStorage.setItem('busqueda','');
    localStorage.setItem('paginaActual','1');
    this.limpiarBusqueda();
    this.router.navigate(['/']);
  }
  mandarWhatsapp(){
    // this.router.navigateByUrl('https://wa.me/04123219451?text=Hola');
    const phoneNumber = '+5804123219451'; // Reemplaza esto con el número de teléfono deseado
    const message = 'Hola, requiero información de...'; // Opcional: reemplaza esto con el mensaje predefinido deseado
  
    // Genera la URL de WhatsApp con el número y el mensaje
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    // const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    // Redirige al usuario a la URL de WhatsApp
    // this.router.navigateByUrl(whatsappUrl);
    window.location.href = whatsappUrl;
  }
  navegarAlMenuNuevo() {
    if(!this.globals.configuracion.front.listado.categoria){
      this.snackBar.open("Debe seleccinar una categoria", 'Cerrar');
      this.router.navigate(['/']);
      return;
    }
    this.router.navigate(['/menu-nuevo']);
  }
  carritoProductos(){
    const dialogRef = this.dialog.open(ModalCarritoProductosComponent, {
      autoFocus: false, 
      width: '600px',
      maxWidth: '100%'
    });
  }
}
